import pako from 'pako';

export function decompressGZip(arrayBuffer: ArrayBuffer): ArrayBuffer {
    let array = new Uint8Array(arrayBuffer) as Uint8Array;
    array = pako.inflate(array);
    return array.buffer as ArrayBuffer;
}

export function compressGZip(arrayBuffer: ArrayBuffer): ArrayBuffer {
    let array = new Uint8Array(arrayBuffer) as Uint8Array;
    array = pako.deflate(array);
    return array.buffer as ArrayBuffer;
}
